export const SIDEBAR = [
  'Background information',
  'Change password',
  'Communication preferences',
  'Contact information ',
  'Manage multi-factor authentication',
  'Primary Care Provider (PCP)',
  'Tobacco use status',
];

export const APP_MANAGED_ROUTES = {
  ACCOUNT_MANAGEMENT_SUBPATH: '/account-management',
};

export const MFA_ROUTES = {
  TEST_URL: 'https://test.auth.highmark.com/manage-account/mfa',
  TEST_URL_AMH: 'https://test.auth.allmyhealth.com/manage-account/mfa',
  TEST_URL_BCBSWY: 'https://test.auth.yourwyoblue.com/manage-account/mfa',
  PRODUCTION_URL: 'https://auth.highmark.com/manage-account/mfa',
  PRODUCTION_URL_AMH: 'https://auth.allmyhealth.com/manage-account/mfa',
  PRODUCTION_URL_BCBSWY: 'https://auth.yourwyoblue.com/manage-account/mfa',
};
export const TD_ROUTES = {
  TEST_URL: 'https://test.auth.highmark.com/manage-account/trusted-devices',
  TEST_URL_AMH:
    'https://test.auth.allmyhealth.com/manage-account/trusted-devices',
  TEST_URL_BCBSWY:
    'https://test.auth.yourwyoblue.com/manage-account/trusted-devices',
  PRODUCTION_URL: 'https://auth.highmark.com/manage-account/trusted-devices',
  PRODUCTION_URL_AMH:
    'https://auth.allmyhealth.com/manage-account/trusted-devices',
  PRODUCTION_URL_BCBSWY:
    'https://auth.yourwyoblue.com/manage-account/trusted-devices',
};
